import React, { useState } from 'react';

const SprintCard = ({ sprint, allocations, index }) => {
    const [isOpen, setIsOpen] = useState(false);

    const totalAllocatedHours = allocations.reduce((sum, item) => sum + parseFloat(item.hours), 0);
    const numberOfResources = allocations.length;
    const workingDays = allocations[0]?.workingDays || 10; // Default to 10 working days
    const bandwidth = numberOfResources * 8 * workingDays; 
    const utilizationRate = ((totalAllocatedHours / bandwidth) * 100).toFixed(2);

    return (
        <div className="p-4 bg-white shadow-lg rounded-lg transition-transform hover:scale-105 w-full">
            <div
                className="cursor-pointer bg-gradient-to-r from-blue-200 to-blue-300 p-4 rounded-md flex flex-col justify-between"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="text-gray-800">
                    <p><strong>Sprint {index + 1}:</strong> {sprint.objective || 'N/A'}
                        <span className="text-blue-700 font-semibold cursor-pointer">{isOpen ? ' ▲ Collapse' : ' ▼ Expand'}</span>
                    </p>
                    <p><strong>Start:</strong> {allocations[0].startDate} <strong>End:</strong> {allocations[0].endDate}</p>
                    <p><strong>Working Days:</strong> {workingDays} | <strong>Resources:</strong> {numberOfResources} | <strong>Allocated Hours:</strong> {totalAllocatedHours.toFixed(2)}</p>
                    <p><strong>Bandwidth:</strong> {bandwidth} | <strong>Utilization Rate:</strong> {utilizationRate}%</p>
                </div>
            </div>

            {isOpen && (
                <div className="mt-4 bg-gray-50 rounded-md p-4 shadow-inner">
                    <table className="w-full border-collapse border border-gray-300">
                        <thead>
                            <tr className="bg-gray-200">
                                <th className="border p-2 text-left">Role</th>
                                <th className="border p-2 text-center">Allocated Hours</th>
                                <th className="border p-2 text-center">Utilization (%)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allocations.map((item, idx) => (
                                <tr key={idx} className="hover:bg-gray-100">
                                    <td className="border p-2 text-left">{item.role}</td>
                                    <td className="border p-2 text-center">{item.hours}</td>
                                    <td className="border p-2 text-center">
                                        {((item.hours / (8 * workingDays)) * 100).toFixed(2)}%
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default SprintCard;
